import { Route } from 'react-router-dom';
import CSVUpload from './components/pageComponents/CSVUpload/CSVUpload';
import ServiceRequestUpload from './components/pageComponents/SRUpload/ServiceRequestUpload';
import OfficePracticum from './components/pageComponents/OfficePracticum/OfficePracticum';
import FormCondition from './components/pageComponents/SuperAdmin/FormConditions/FormsCondition';
import { AddOrganizationPage } from './components/pageComponents/SuperAdmin/Organization/AddOrganizationPage';
import { EditOrganizationPage } from './components/pageComponents/SuperAdmin/Organization/EditOrganization';
import Prompts from './components/pageComponents/SuperAdmin/Prompts/Prompts';
import SuperAdmin from './components/pageComponents/SuperAdmin/SuperAdmin';
import Templates from './components/pageComponents/Templates/Templates';
import HumanScribe from './components/pageComponents/SuperAdmin/HumanScribe/HumanScripe';
import AiComponents from './components/pageComponents/SuperAdmin/AI/Ai';
import Agents from './components/pageComponents/SuperAdmin/Agents/ListAgents';

export const getSuperAdminRoutes = ({ isMinimized }) => {
  const pages = [
    {
      path: '/superadmin',
      Component: SuperAdmin,
    },
    {
      path: '/superadmin/addOrganization',
      Component: AddOrganizationPage,
    },
    {
      path: '/superadmin/editOrganization',
      Component: EditOrganizationPage,
    },
    {
      path: '/csvupload',
      Component: CSVUpload,
    },
    {
      path: '/sr-upload',
      Component: ServiceRequestUpload,
    },
    {
      path: '/prompts',
      Component: Prompts,
    },
    {
      path: '/ai',
      Component: AiComponents,
    },
    {
      path: '/agents',
      Component: Agents,
    },
    {
      path: '/formconditions',
      Component: FormCondition,
    },
    {
      path: '/templates',
      Component: Templates,
    },
    {
      path: '/humanScribe',
      Component: HumanScribe,
    },
    {
      path: '/superadmin/officepracticum',
      Component: OfficePracticum,
    },
  ];

  return pages.map((route, index) => {
    const { path, Component } = route;
    return (
      <Route
        key={index}
        path={path}
        element={<Component isMinimized={isMinimized} />}
      />
    );
  });
};
